import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { SellerAccountClient } from 'src/WebApiController';

export function useInsertCustomPaymentTypeMutation(
  paymentContext: 'Sale' | 'PO' = 'Sale'
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn({ name }: { name: string }) {
      return new SellerAccountClient(
        activeAccountWebClientConfig
      ).insertCustomPaymentType({ id: 0, name }, paymentContext);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          'getCustomPaymentTypes',
          activeAccountWebClientConfig.activeAccountId,
          paymentContext,
        ],
      });
    },
  });
}
